import { render, staticRenderFns } from "./BoxAtividadesAtrasadas.vue?vue&type=template&id=3ac019da"
import script from "./BoxAtividadesAtrasadas.vue?vue&type=script&lang=js"
export * from "./BoxAtividadesAtrasadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports